import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';

import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material/dialog';

import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { NotificationService } from 'src/app/shared/notification.service';
import { NotaCreditoProveedorService } from 'src/app/services/api/notaCreditoProveedor.sales.service';
import { NCPProjectExpression } from 'src/features/service-order/services-os-actions/ui/nota-credito-proveedor/nota-credito-proveedro';
import { ConfirmDeleteComponent } from 'src/features/service-order/services-os-actions/ui/nota-credito-proveedor/confirm-delete/confirm-delete.component';

@Component({
  selector: 'app-nota-credito-proveedor',
  templateUrl: './nota-credito-proveedor.component.html',
  styleUrls: ['./nota-credito-proveedor.component.css'],
})
export class NotaCreditoProveedorComponent implements OnInit {
  confirmGuardar = false;
  confirmAllDelete = false;

  loadingSubmit: boolean = false;
  loadingUpdate: boolean = false;

  loading: boolean = true;

  isGetMultimediaLoading: boolean = true;
  isMutationsMultimediaLoading: boolean = true;

  numberOS: any = this.data.numberOS;
  success: boolean = false;
  myForm: FormGroup;
  usuario: string | null = null;

  id: string | null = null;
  codigo: string | null = null;

  nota = {
    fileNumber: this.data.fileNumber,
    nameProveedor: this.data.nameProveedor,
    idProveedor: this.data.idProveedor,
    numberOS: this.data.numberOS,
    idItinerary: this.data.idItinerary,
    estado: 'CREADO',
    moneda: this.data.moneda,
  };
  ErrorFetch: null | string = null;
  @Output() disparadorCambios = new EventEmitter<any[]>();
  constructor(
    public dialogRef: MatDialogRef<NotaCreditoProveedorComponent>,
    public dialog: MatDialog,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private NCPService: NotaCreditoProveedorService,
    private notificationService: NotificationService
  ) {
    this.myForm = this.fb.group({
      reef: new FormControl('', Validators.required),
      saf: new FormControl('', Validators.required),
      penalidad: new FormControl('', Validators.required),
      partialPayment: new FormControl('', Validators.required),
    });
  }

  onFinishLoading(value: boolean) {
    this.isGetMultimediaLoading = value;
    console.log('Valor recibido del hijo:', value);
  }

  onFinishLoadingMutations(value: boolean) {
    this.isMutationsMultimediaLoading = value;
  }

  ngOnInit(): void {
    this.usuario = localStorage.getItem('email');
    this.getNotaCreditoProveedorByNumberOS();
  }

  getNotaCreditoProveedorByNumberOS() {
    if (this.data.numberOS && this.data.numberOS.toString() != '') {
      this.NCPService.getNotaCreditoProveedorByNumberOS({
        numberOS: this.data.numberOS,
        ProjectionExpression: NCPProjectExpression.join(','),
      }).subscribe({
        next: (resp: any) => {
          this.loading = false;
          if (resp.errors) {
            this.notificationService.notifyError(resp.errors[0].message);
            return;
          }

          const notaCreditoProveedor = resp.getNotaCreditoProveedorByNumberOS;
          if (!notaCreditoProveedor) return;
          this.id = notaCreditoProveedor?.id || null;
          this.codigo = notaCreditoProveedor?.codigo || null;
          this.myForm.get('reef')?.setValue(notaCreditoProveedor.reef || 0);
          this.myForm.get('saf')?.setValue(notaCreditoProveedor.saf || 0);
          this.myForm
            .get('penalidad')
            ?.setValue(notaCreditoProveedor.penalidad || 0);
          this.myForm
            .get('partialPayment')
            ?.setValue(notaCreditoProveedor.partialPayment || 0);
        },
        error: (error: any) => {
          this.loading = false;
          console.error('error al crear NCP:', error);
          this.notificationService.notifyError(
            error.message || 'Error al generar NCP.'
          );
        },
      });
    } else {
      this.loading;
    }
  }

  onNumberInput(event: any) {
    const input = event.target.value;
    const numericValue = input
      .replace(/[^0-9.]/g, '')
      .replace(/(\..*?)\..*/g, '$1');
    if (input !== numericValue) {
      this.myForm.get(event.target.name)?.setValue(numericValue);
    }
  }

  suamTotalesNCP() {
    let total = 0;
    if (this.myForm.value.reef) total += Number(this.myForm.value.reef);
    return total;
  }

  handleCreateNCP() {
    const numberOS = Number(this.data.numberOS);
    const notaCredito = this.nota;

    this.loadingSubmit = true;
    this.NCPService.createNotaCreditoProveedor({
      notaCredito: {
        ...notaCredito,
        reef: Number(this.myForm.value.reef),
        saf: Number(this.myForm.value.saf),
        penalidad: Number(this.myForm.value.penalidad),
        partialPayment: Number(this.myForm.value.partialPayment),
        numberOS: numberOS.toString(),
        usuario: this.usuario!,
      },
      usuario: this.usuario!,
    }).subscribe({
      next: (resp: any) => {
        this.loadingSubmit = false;
        if (resp.errors) {
          this.notificationService.notifyError(resp.errors[0].message);
          return;
        }
        this.confirmGuardar = true;
        this.id = resp.createNotaCreditoProveedor.id;
        this.codigo = resp.createNotaCreditoProveedor.codigo;
        this.success = true;
        this.notificationService.showSuccessAlert(
          'Se genero la de Nota de credito .',
          () => {
            this.OnClose();
          }
        );
      },
      error: (error: any) => {
        this.loadingSubmit = false;
        console.error('error al crear NCP:', error);
        this.notificationService.notifyError(
          error.message || 'Error al generar NCP.'
        );
      },
    });
  }
  handleUpdateNCP() {
    console.log({
      notaCredito: {
        reef: Number(this.myForm.value.reef),
        saf: Number(this.myForm.value.saf),
        penalidad: Number(this.myForm.value.penalidad),
        partialPayment: Number(this.myForm.value.partialPayment),
        usuario: this.usuario,
      },
    });
    this.loadingSubmit = true;
    this.NCPService.updateNotaCreditoProveedor({
      updates: {
        reef: Number(this.myForm.value.reef),
        saf: Number(this.myForm.value.saf),
        penalidad: Number(this.myForm.value.penalidad),
        partialPayment: Number(this.myForm.value.partialPayment),
        usuario: this.usuario!,
      },
      id: this.id!,
    }).subscribe({
      next: (resp: any) => {
        this.loadingSubmit = false;
        if (resp.errors) {
          this.notificationService.notifyError(resp.errors[0].message);
          return;
        }
        this.confirmGuardar = true;
        this.success = true;
        this.notificationService.showSuccessAlert(
          'Se actualizo la de Nota de credito .',
          () => {
            this.OnClose();
          }
        );
      },
      error: (error: any) => {
        this.loadingSubmit = false;
        console.error('error al actualizar NCP:', error);
        this.notificationService.notifyError(
          error.message || 'Error al actualizar NCP.'
        );
      },
    });
  }

  submitForm() {
    console.log('submitForm');
    console.log('usuario', this.usuario);
    if (!this.usuario) {
      this.notificationService.notifyError('Usuario no definido.');
      return;
    }
    if (this.id) this.handleUpdateNCP();
    else this.handleCreateNCP();
  }

  HandleconfirmAllDelete() {
    this.confirmAllDelete = true;
  }

  openDialogDelete(): void {
    if (!this.id || this.id === '') {
      this.notificationService.notifyWarning(
        'No hay NCP para eliminar, porfavor proporcione un id valido.'
      );
      return;
    }
    let dialogRef = this.dialog.open(ConfirmDeleteComponent, {
      width: '512px',
      height: '340px',
      data: { id: this.id, onConfirm: this.HandleconfirmAllDelete.bind(this) },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.success === true) {
        this.OnClose();
      }
    });
  }

  OnClose() {
    this.dialogRef.close({
      numberOS: this.data.numberOS,
      success: this.success,
    });
  }

  onCancel() {
    this.OnClose();
  }

  ngOnDestroy(): void {
    this.onCancel();
  }
}
